<template>
  <footer>
    <div class="flexFooter">
      <div class="imgBox">
        <img src="../assets/webLogo.svg" alt="" />
      </div>
      <div class="infoBox">
        <h3>Información de contacto</h3>
        <ul>
          <li><b-icon icon="geo-alt"></b-icon>Chía, Cundinamarca Colombia</li>
          <li><b-icon icon="telephone-fill"></b-icon>(+57) 3208932127</li>
          <li><b-icon icon="at"></b-icon>info@overlabingenieria.com.co</li>
        </ul>
      </div>
      <div class="infoBox">
        <h3>Sitios</h3>
        <ul>
          <li><a href="/about">CONÓZCANOS</a></li>
          <li><a href="/services">NUESTROS SERVICIOS</a></li>
          <li><a href="/contact">CONTÁCTENOS</a></li>
        </ul>
      </div>
      <div class="infoBox">
        <h3>Ilustraciones</h3>
        <ul>
          <li><a href="http://www.freepik.com">Designed by macrovector / Freepik</a></li>
          <li><a href="http://www.freepik.com">Designed by Freepik</a></li>
          <li><a href="http://www.freepik.com">Designed by macrovector / Freepik</a></li>
          <li><a href="http://www.freepik.com">Designed by fullvector / Freepik</a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name:"MyFooter"
};
</script>

<style lang="css" scoped>
.flexFooter {
  width: 100%;
  min-height: 200px;
  background: var(--back);
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 25px;
   -webkit-box-pack: start; -ms-flex-pack: start; justify-content: flex-start; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start;
}
.flexFooter .imgBox {
  padding: 0 25px;
  position: relative;
}
.flexFooter .imgBox img {
  width: 100%;
}
.flexFooter .infoBox {
  margin-left: 25px;
  position: relative;
}
.flexFooter .infoBox ul {
  list-style: none;
}
.flexFooter .infoBox ul li a {
  text-decoration: none;
  color: var(--textColor);
}
.flexFooter .infoBox ul li a:hover {
  color: var(--primary);
}
li{
  font-size: 0.8rem;
}
</style>
